import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { OperationRequestData } from "../../data/operationRequestData";
import { OperationModel } from "../operations/operationModel";
import i18n from "@/i18n";

/** Модель регистрации пользователя  */
export class RegisterModel extends OperationModel {
  /**Номер договора, счета или карты*/
  public AccountNumber: string = "";

  /** Номер телефона */
  public Phone: string = "";

  /**Правила заполнения номера телефона */
  public PhoneRules: Array<Function> = [
    (p: any) => !!p || i18n.t("auth.errors.phoneEmpty"),
    (p: any) =>
      (p && /^\+7\([0-9]{3}\)[0-9]{3}-[0-9]{2}-[0-9]{2}$/.test(p)) ||
      i18n.t("auth.errors.phoneCheck")
  ];

  /**Правила заполнения номера карты/счета */
  public AccountNumberRules: Array<any> = [
    (l: any) => !!l || i18n.t("auth.errors.accountNumberCheck")
  ];

  /**Маска телефона*/
  public PhoneMask: string = '+7(###)###-##-##';

  /**Фамилия */
  public SurName: string = "";

  /**Имя */
  public Name: string = "";

  /** Отчество */
  public Patronymic: string = "";

  /**Серия и номер документа */
  public DocumentSN: string = "";

  /** ИНН */
  public Inn: string = "";

  /**Кодовое слово */
  public CodeWord: string = "";

  /**Логин клиента (приходит с сервера) */
  public Login: string =  "";

  /**Текст после успешного исполнения */
  public SuccessMessage: string = "";

  constructor() {
    super();
  }

  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = new OperationRequestData();
    ord.respondentCode = this.RespondentCode;
    ord.operationId = this.OperationId;

    ord.setProperty("surname", this.SurName, DeclarationPropertiesTypes.String);
    ord.setProperty("name", this.Name, DeclarationPropertiesTypes.String);
    ord.setProperty(
      "secondname",
      this.Patronymic,
      DeclarationPropertiesTypes.String
    );
    ord.setProperty(
      "mainDocNumber",
      this.DocumentSN.replace(/\s/g, ""),
      DeclarationPropertiesTypes.String
    );
    ord.setProperty("account", this.AccountNumber.replace(/\s/g, ""), DeclarationPropertiesTypes.String);
    ord.setProperty("inn", this.Inn, DeclarationPropertiesTypes.String);
    ord.setProperty(
      "phone",
      this.Phone.replace(/\s|\(|\)|\-/g, ""),
      DeclarationPropertiesTypes.String
    );
    ord.setProperty(
      "codeword",
      this.CodeWord,
      DeclarationPropertiesTypes.String
    );

    return ord;
  }

  /**
   * Заполнение операции данными из ответа запроса.
   * @param ord Данные запроса.
   * @param bAssign Признак assign.
   */
   public setOperationFromRequest(ord: OperationRequestData): void {
    this.Login = ord.getPropertyValue("login");
    this.SuccessMessage = i18n.t("auth.messages.successregister", { login: this.Login }).toString(); 
  }
}
